module.exports = "#feedback_button {\n  background: url(\"http://air-staging-assets.s3.amazonaws.com/assets/feedback_icon.png\") 0 0 no-repeat transparent;\n  height: 67px;\n  width: 67px;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 9999999; }\n\n#formModal {\n  z-index: 99999999; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/feedback/feedback.component.scss
// module id = ./src/app/components/feedback/feedback.component.scss
// module chunks = main